import { createContext, useContext, useState, useCallback } from "react";

const EditModeContext = createContext(null);

export const EditModeProvider = ({ children }) => {
	const [editField, setEditField] = useState(null);
	const cancelEditMode = useCallback(() => setEditField(null), []);

	const isEditing = (scope, field, id = null, parentId = null) => {
		if (!editField) {
			return false;
		}
		const { scope: s, field: f, id: activeId, parentId: activeParentId } = editField
		return (s === scope && f === field && (id === null || activeId === id) && (parentId === null || activeParentId === parentId));
	};

	return (
		<EditModeContext.Provider value={{ editField, setEditField, isEditing, cancelEditMode }}>
			{children}
		</EditModeContext.Provider>
	);
};

export const useEditMode = () => useContext(EditModeContext);
